import { createContext } from 'react';

interface OrderInfoContextType {
	isOpen: boolean;
	toggleOpen: () => void;
	selectedId: number;
	selectedInfoId: number;
	setSelectedId: (id: number) => void;
	setSelectedInfoId: (id: number) => void;
	close: () => void;
	open: () => void;
}

export const OrderInfoContext = createContext<OrderInfoContextType | undefined>(
	undefined,
);
